import { Box, Button, Typography } from "@mui/material";
import { useUpdatePurchase } from "@mutations/useUpdatePurchase";

export default function UpdatePurchaseButton({ uuid }: { uuid: string }) {
  const { mutate, data, isPending, isError, isSuccess, error } = useUpdatePurchase();

  const handleCreatePurchase = () => {
    const variables = {
      uuid,
      items: [{ sku: "SYS003", quantity: 1 }],
      billing_address: { postal_code: "10001" },
      shipping_address: {
        address1: "123 St",
        address2: "",
        city: "NYC",
        state: "NY",
        country: "USA",
        postal_code: "10001",
      },
      shipmentMethod: "fedex_priority_overnight",
    };
    mutate(variables);
  };

  return (
    <Box sx={{ p: "24px" }}>
      <Button onClick={handleCreatePurchase} variant="contained">
        {isPending ? "Updating..." : "Update Purchase"}
      </Button>

      {isSuccess && (
        <Typography sx={{ mt: "16px", color: "green" }}>
          ✅ Created! UUID: {JSON.stringify(data)}
        </Typography>
      )}

      {isError && (
        <Typography sx={{ mt: "16px", color: "red" }}>
          ❌ Error: {(error as Error).message}
        </Typography>
      )}
    </Box>
  );
}
